import React from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
    handleClose();
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, cursor: "pointer" }}
            onClick={() => navigate("/dashboard")}
          >
            {t("nav.appTitle")}
          </Typography>
          <Button color="inherit" onClick={() => navigate("/dashboard")}>
            {t("nav.dashboard")}
          </Button>
          {user && user.role === "admin" && (
            <>
              <Button color="inherit" onClick={() => navigate("/users")}>
                {t("nav.users")}
              </Button>
              <Button
                color="inherit"
                onClick={() => navigate("/admin-settings")}
              >
                {t("nav.adminSettings")}
              </Button>
            </>
          )}
          <LanguageSwitcher />
          {user && (
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem disabled>
                  <Typography variant="body2">{user.displayName}</Typography>
                </MenuItem>
                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {user.role === "admin"
                      ? "管理者"
                      : user.role === "support"
                      ? "担当者"
                      : "一般ユーザー"}
                  </Typography>
                </MenuItem>
                {user.role === "admin" && (
                  <>
                    <MenuItem
                      onClick={() => {
                        handleClose();
                        navigate("/users");
                      }}
                    >
                      {t("nav.users")}
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleClose();
                        navigate("/admin-settings");
                      }}
                    >
                      {t("nav.adminSettings")}
                    </MenuItem>
                  </>
                )}
                {(user.role === "support" || user.role === "admin") && (
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      navigate("/settings");
                    }}
                  >
                    {t("nav.settings")}
                  </MenuItem>
                )}
                <MenuItem onClick={handleLogout}>{t("nav.logout")}</MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <Container component="main" sx={{ flexGrow: 1, py: 3 }}>
        {children}
      </Container>
    </Box>
  );
};

export default Layout;
